const local = {
  info: {
    REACT_APP_WEBSITE_URL: "https://www.akira.ai",
  },
  bookdemo: {
    Link: "https://agentsearch-bookdemo.lab.neuralcompany.team/agentsearch",
  },
};

const dev = {
  auth: {
    REACT_APP_AUTH_URL: "https://akiraai-auth.neuralcompany.team/api/auth",
  },
  app: {
    WORKSPACE_DOMAIN_NAME: ".neuralcompany.team",
  },
  info: {
    REACT_APP_WEBSITE_URL: "https://akiraai.neuralcompany.team",
  },
  bookdemo: {
    Link: "https://agentsearch-bookdemo.lab.neuralcompany.team/agentsearch",
  },
};

const prod = {
  auth: {
    REACT_APP_AUTH_URL: "https://app.akira.ai/api/auth",
  },
  app: {
    WORKSPACE_DOMAIN_NAME: ".akira.ai",
  },
  info: {
    REACT_APP_WEBSITE_URL: "https://www.akira.ai",
  },
  bookdemo: {
    Link: "https://demo.elixirdata.co/",
  },
};

const config =
  process.env.REACT_APP_STAGE === "production"
    ? prod
    : process.env.REACT_APP_STAGE === "development"
    ? dev
    : // : process.env.REACT_APP_STAGE === "uat"
      // ? uat
      local;
// eslint-disable-next-line
export default {
  ...config,
};
